import React from 'react';

const TextFieldLabel = (props) => {
	const { className, label, children } = props;
	return (
		<label className={`label-input${className ? " " + className : ""}`}>{label ? label : children}</label>
	)	
}

export default TextFieldLabel;